// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"f90aed22","239":"a7673412","453":"96db13be"}[chunkId] + ".chunk.js";
};